import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=bf3615e8&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf3615e8"]])

export default __exports__